var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"legend"},[_c('span',[_vm._v("test")]),_c('span',[_vm._v("this")])])}]

export { render, staticRenderFns }